module.exports = "<footer class=\"footer\">\r\n    <div class=\"container\">\r\n        &copy; 2018 {{'app_title' | translate}}\r\n    </div>\r\n</footer>"